export default {
  id: "",
  sessionDbId: "",
  isPreview: null,
  client: {},
  rep: {},
  pages: [],
  allCmsPages: [],
};
